import { render } from "./UsePolicy.vue?vue&type=template&id=563383f7"
import script from "./UsePolicy.vue?vue&type=script&lang=js"
export * from "./UsePolicy.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__